/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from "react";

class WaitingComponent extends React.Component {
    render() {

        if (this.props.small) {
            return <div className="text-center" style={{ height: "20px;"}}>
                <div className="spinner-grow text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        }
        return <div className="text-center mb-5">
            <div className="spinner-grow text-primary" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    }
}

export default WaitingComponent;
